import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledToastProps {
  theme: any;
}
export const StyledToast = styled.div<StyledToastProps>`
  ${({ theme }) => theme.trigger_hide_toast && 'display: none !important'};
  position: fixed;
  top: ${pxToRem(20)};
  right: ${pxToRem(20)};
  border: 1px solid #eee;
  ${({ color }) => color && `border-left: 6px solid ${color}`};
  background: white;
  border-radius: ${pxToRem(6)};
  min-width: ${pxToRem(320)};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${pxToRem(20)};
  justify-content: space-between;
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: ${pxToRem(20)};

  div {
    display: flex;
    flex-direction: column;
    max-width: ${pxToRem(300)};
  }
`

export const StyledIcon = styled.div`
  svg {
    width: ${pxToRem(30)};
    height: ${pxToRem(30)};
    margin-right: ${pxToRem(20)};
  }
`

export const StyledClose = styled.div`
  cursor: pointer;

  svg {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    color: #898989;
  }
`
